<div class="container-fluid search-container">
    <div class="row">
        <div class="col">
            <div class="form-group-container form-group mx-0 row">
                <label class="col-xs-12 col-md-3 my-auto pl-0">Numéro</label>
                <div class="col-xs-12 col-md-9 px-0">
                    <div class="form-control form-control-read">
                        {{ faultedInvoice.Number }}
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col">
            <div class="form-group-container form-group mx-0 row">
                <label class="col-xs-12 col-md-3 my-auto pl-0">Type de facture</label>
                <div class="col-xs-12 col-md-9 px-0">
                    <div class="form-control form-control-read">
                        {{ faultedInvoice.AmountTaxExcluded | currency:'€' }}
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col">
            <div class="form-group-container form-group mx-0 row">
                <label class="col-xs-12 col-md-3 my-auto pl-0">Nom fournisseur</label>
                <div class="col-xs-12 col-md-9 px-0">
                    <div class="form-control form-control-read">
                        {{ faultedInvoice.SupplierRecipientName }}
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col">
            <div class="form-group-container form-group mx-0 row">
                <label class="col-xs-12 col-md-3 my-auto pl-0">Référence 1</label>
                <div class="col-xs-12 col-md-9 px-0">
                    <div class="form-control form-control-read">
                        {{ faultedInvoice.PrimaryReference }}
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col">
            <div class="form-group-container form-group mx-0 row">
                <label class="col-xs-12 col-md-3 my-auto pl-0">Statut actuel</label>
                <div class="col-xs-12 col-md-9 px-0">
                    <div class="form-control form-control-read">
                        {{ faultedInvoice.State | invoiceState }}
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col">
            <div class="form-group-container form-group mx-0 row">
                <label class="col-xs-12 col-md-3 my-auto pl-0">Statut attendu</label>
                <div class="col-xs-12 col-md-9 px-0">
                    <div class="form-control form-control-read">
                        {{ faultedInvoice.ExpectedState | invoiceState }}
                    </div>
                </div>
            </div>  
        </div>
    </div>
    <div class="row">
        <div class="col">
            <div class="form-group-container form-group mx-0 row">
                <label class="col-xs-12 col-md-3 my-auto pl-0">Date OCR</label>
                <div class="col-xs-12 col-md-9 px-0">
                    <div class="form-control form-control-read">
                        {{ faultedInvoice.OcrDate | date:'dd/MM/yyyy HH:mm:ss' }}
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col">
            <div class="form-group-container form-group mx-0 row">
                <label class="col-xs-12 col-md-3 my-auto pl-0">Date d'échéance</label>
                <div class="col-xs-12 col-md-9 px-0">
                    <div class="form-control form-control-read">
                        {{ faultedInvoice.DueDate | date:'dd/MM/yyyy' }}
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col">
            <div class="form-group-container form-group mx-0 row">
                <label class="col-xs-12 col-md-3 my-auto pl-0">Type de facture</label>
                <div class="col-xs-12 col-md-9 px-0">
                    <div class="form-control form-control-read">
                        {{ faultedInvoice.TypeName }}
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col">
            <button type="button" class="btn btn-secondary btn-sm btn-block" tooltip="Télécharger la facture"
                (click)="onDownload()">
                Télécharger la facture
            </button>
        </div>
        <div class="col">
            <button type="button" class="btn btn-secondary btn-sm btn-block" tooltip="Fermer"
                (click)="onClose()">
                Fermer
            </button>
        </div>
    </div>
</div>